import { render } from "./ConfirmedDetectsView.vue?vue&type=template&id=35b7c1be"
import script from "./ConfirmedDetectsView.vue?vue&type=script&lang=js"
export * from "./ConfirmedDetectsView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__